import useMutation from "src/hooks/useMutation";

function useBatchUpdate(id) {
  const path = !!id ? `/api/v1/batches/${id}` : "/api/v1/batches/id";
  return useMutation({
    path: path,
    method: "PUT",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/batches`,
      shouldRevalidate: true,
    },
  });
}

export default useBatchUpdate;
